import { Event } from 'betweb-openapi-axios'

import { RootState } from 'shared/types/store'

import { initialState } from './slice'

export const selectIsShowBasketOnSmallWindow = (state: RootState) =>
  state.rightBasketContainerState?.layout?.isShowBasketOnSmallWindow ??
  initialState.layout.isShowBasketOnSmallWindow

export const selectIsRejectedEventId = (
  state: RootState,
  eventId: Event['id']
) => {
  return state.basketProvider.competitorConstraints.rejectedEventIds.includes(
    eventId
  )
}
